import { Icon as ChakraIcon, IconProps, ResponsiveValue } from '@chakra-ui/react';
import React, { ElementType } from 'react';

interface CustomIconProps extends IconProps {
  icon: ElementType;
  size?: ResponsiveValue<string>;
  color?: string;
  padding?: string;
  bgColor?: string;
  handleOnClick?: () => void;
}

export const CustomIcon: React.FC<CustomIconProps> = ({
  icon: IconComponent,
  size = '24px',
  color,
  padding,
  handleOnClick,
  bgColor,
}) => {
  return (
    <ChakraIcon
      as={IconComponent}
      boxSize={size}
      color={color}
      padding={padding}
      onClick={handleOnClick}
      bg={bgColor}
    />
  );
};
